import { ICON_FIELD, ICON_FIELD2, IMAGE_MOBILE, IMAGE_DESKTOP } from '../elements/assets'
import { LINK_TITLE } from '../elements/link'

export const INDUSTRY_SHOWCASE = `
...on industryShowcase_Entry {
  id
  typeHandle

  heading: headingAdvanced { html }
  simpleCkeditor { html }

  items: industryShowcaseItems {
    ... on industryShowcaseItem_Entry {
      id
      title

      ${ ICON_FIELD }

      ${ LINK_TITLE }

      ${ IMAGE_MOBILE }
      ${ IMAGE_DESKTOP }
      ${ ICON_FIELD2 }
      textBlock

    }
  }
}
`